import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { Transform } from 'class-transformer';
import { format } from 'fecha';

export interface CurrencyExchangeRate {
    readonly date: Date;
    readonly manual: boolean;
    readonly rate: number;
    readonly tableNo: string | null;
    readonly units: number;
}

class CurrencyExchangeRateInternalItemDTO {
    @Transform(transformDTODate, { toClassOnly: true }) public readonly date: Date;
    public readonly rate: number;
    public readonly tableNo: string;
    public readonly units: number;
}

export class CurrencyExchangeRateQuery extends Query<CurrencyExchangeRate | null> {
    public constructor(public readonly params: {
        currency: string;
        date: Date
    }) {
        super();
    }
}

export class CurrencyExchangeRateQueryHandlerBase implements QueryHandler<CurrencyExchangeRateQuery, CurrencyExchangeRate | null> {
    public static Url = TaggedUrl.join('system/currencies/:symbol/rates/:date', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: CurrencyExchangeRateQuery): Promise<CurrencyExchangeRate | null> {
        const url = fillPlaceholders(CurrencyExchangeRateQueryHandlerBase.Url, {
            symbol: query.params.currency,
            date: format(query.params.date, DataFormats.date.webApi)
        });
        try {
            const { data } = await this.http.get(url, {
                dto: CurrencyExchangeRateInternalItemDTO
            });
            return data ? {
                date: data.date,
                manual: false,
                rate: data.rate,
                units: data.units,
                tableNo: data.tableNo
            } : null;
        } catch (err) {
            return null;
        }
    }
}
